export class BaseChildReduxAction {
  parentKey: string;
  constructor(init: Partial<BaseChildReduxAction>) {
    Object.assign(this, init);
  }
}
